import request from '@/utils/request'
import { SYSTEM_URL } from '@/api/baseUrl'

/**
 * 获取数据
 * @param {*} params
 */
export function get(params) {
  return request({
    url: SYSTEM_URL() + '/menu/permissions',
    method: 'get'
  })
}
